import React , {useEffect , useState} from 'react';
import {getCookie} from "../../utils";
import locked from '../../style/images/locked.png';

const Failed = () => {
    const [referer , setReferer] = useState("");
    useEffect(() => {
        setReferer(getCookie("refererSite"))
    } , []);
    return (
        <div className="locked-wrapper">
            <div className="locked">
                <img src={locked} alt="failed"/>
            </div>
            <div style={{marginTop: 15}}>
                <p className="failed-msg">!شما به این صفحه دسترسی ندارید</p>
            </div>
            <div>
                {
                    referer === ""  ? <span></span>
                        :
                        referer === undefined ?
                            <span></span>
                            :
                            <button className="failed-back-btn" onClick={() => window.location.href=getCookie("refererSite")}>بازگشت به صفحه ی پذیرنده</button>
                }
            
            </div>
        </div>
    )
};
export default Failed;